var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        [
          _c(
            "v-btn-toggle",
            {
              staticClass: "mr-4",
              attrs: { mandatory: "", dense: "" },
              model: {
                value: _vm.statusFilter,
                callback: function($$v) {
                  _vm.statusFilter = $$v
                },
                expression: "statusFilter"
              }
            },
            [
              _c("v-btn", { attrs: { value: "all", small: "" } }, [
                _vm._v(_vm._s(_vm.$t("processes.filterAll")))
              ]),
              _c(
                "v-btn",
                {
                  attrs: {
                    value: "Running",
                    small: "",
                    color: "info",
                    outlined: ""
                  }
                },
                [_vm._v(_vm._s(_vm.$t("processes.filterRunning")))]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    value: "Completed",
                    small: "",
                    color: "success",
                    outlined: ""
                  }
                },
                [_vm._v(_vm._s(_vm.$t("processes.filterCompleted")))]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    value: "Failed",
                    small: "",
                    color: "error",
                    outlined: ""
                  }
                },
                [_vm._v(_vm._s(_vm.$t("processes.filterFailed")))]
              )
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: {
                icon: "",
                loading: _vm.loading,
                title: _vm.$t("processes.refresh")
              },
              on: { click: _vm.refresh }
            },
            [_c("v-icon", [_vm._v("mdi-refresh")])],
            1
          )
        ],
        1
      ),
      _vm.error
        ? _c(
            "v-alert",
            { staticClass: "mx-4", attrs: { type: "error", dense: "" } },
            [_vm._v(_vm._s(_vm.error))]
          )
        : _vm._e(),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.filteredRuns,
          loading: _vm.loading,
          "items-per-page": 50,
          "footer-props": { "items-per-page-options": [25, 50, 100] },
          "sort-by": "startedAt",
          "sort-desc": true,
          "show-expand": "",
          "item-key": "processRunId",
          dense: ""
        },
        scopedSlots: _vm._u([
          {
            key: "item.status",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "v-chip",
                  {
                    attrs: {
                      small: "",
                      color: _vm.statusColor(item.status),
                      dark: ""
                    }
                  },
                  [_vm._v(_vm._s(item.status))]
                )
              ]
            }
          },
          {
            key: "item.triggerType",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "v-chip",
                  {
                    staticClass: "caption",
                    attrs: { small: "", color: "grey lighten-2" }
                  },
                  [_vm._v(_vm._s(item.triggerType))]
                )
              ]
            }
          },
          {
            key: "item.startedAt",
            fn: function(ref) {
              var item = ref.item
              return [
                _vm._v(" " + _vm._s(_vm.formatDate(item.startedAt)) + " ")
              ]
            }
          },
          {
            key: "item.durationSeconds",
            fn: function(ref) {
              var item = ref.item
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      item.durationSeconds != null
                        ? item.durationSeconds.toFixed(1) + "s"
                        : "—"
                    ) +
                    " "
                )
              ]
            }
          },
          {
            key: "item.errorMessage",
            fn: function(ref) {
              var item = ref.item
              return [
                item.errorMessage
                  ? _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "", "max-width": "400" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "span",
                                    _vm._g(
                                      {
                                        staticClass: "error--text",
                                        staticStyle: { cursor: "pointer" }
                                      },
                                      on
                                    ),
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("truncate")(
                                              item.errorMessage,
                                              60
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [_c("span", [_vm._v(_vm._s(item.errorMessage))])]
                    )
                  : _c("span", [_vm._v("—")])
              ]
            }
          },
          {
            key: "expanded-item",
            fn: function(ref) {
              var headers = ref.headers
              var item = ref.item
              return [
                _c(
                  "td",
                  { staticClass: "pa-3", attrs: { colspan: headers.length } },
                  [
                    item.metadataJson
                      ? _c(
                          "pre",
                          {
                            staticClass: "caption",
                            staticStyle: { "white-space": "pre-wrap" }
                          },
                          [_vm._v(_vm._s(_vm.prettyJson(item.metadataJson)))]
                        )
                      : _c("span", { staticClass: "grey--text caption" }, [
                          _vm._v(_vm._s(_vm.$t("processes.noMetadata")))
                        ])
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }